import { Flex, Layout } from 'antd';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './public.layout.module.scss';
import Icon from '@ant-design/icons';
import Star from '@/assets/icons/stars-01.svg?react';
import bubbleImage from '@/assets/images/bubble.svg';
import bubble1Image from '@/assets/images/bubble-1.svg';

interface PublicLayoutProps {
  children: ReactNode;
}

const { Content } = Layout;

export default function PublicLayout({ children }: PublicLayoutProps) {
  const { t } = useTranslation('auth');

  return (
    <Layout hasSider data-testid="public-layout">
      <Flex className={styles.sider}>
        <img className={styles.bubble} src={bubbleImage} />
        <img className={styles.bubble1} src={bubble1Image} />

        <Icon className={styles.stars} component={Star} />
        <h1 className={styles.heading}>{t('publicLayout.heading')}</h1>
        <p className={styles.text}>{t('publicLayout.text')}</p>
      </Flex>
      <Layout data-testid="public-layout-content">
        <Content className={styles.content}>{children}</Content>
      </Layout>
    </Layout>
  );
}
